import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import SinDatos from "../general/sin_registros"
import { Button, ButtonGroup, Card, Col, Modal, Row, Tab, Table, Tabs } from "react-bootstrap"
import { estilo_last_mile } from "../../lib/global/styles"
import { LiaHandPointerSolid } from 'react-icons/lia'
import { sliceIntoChunks } from "../../lib/helpers/helpers"
import { urlapi } from "../../lib/backend/data"
import { cerrarSesion } from "../../redux/actions/session"
import { toast } from "react-toastify"
import CargandoFlotante from "../general/cargando_flotante"
import { formatoMoneda } from "../../lib/helpers/main"
import RegistrosVacios from "../general/registros_vacios"
import { getDireccion1 } from "../../lib/helpers/pedidos/pedidos"
import TablaOrdenes from "../ordenes/tabla_registros"
import { BiSolidChevronRight, BiSolidSend } from "react-icons/bi"
import { PiWarningCircleBold } from "react-icons/pi"
import { confirmAlert } from "react-confirm-alert"
import { Bar } from 'react-chartjs-2';
import SelectorBodega from "../bodega/bodegas/selector_bodega"
import RutasImportador from "../rutas/importador/importador"


const default_proveedores = [
    {
        titulo: "Starken",
        slug: "starken",
        logo: "https://www.selahcreaciones.cl/imagenes/otros/starkenlogo.png"
    },
    {
        titulo: "Varmontt",
        slug: "varmontt",
        logo: "data:image/png;base64,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"
    },
    {
        titulo: "Chile Express",
        slug: "chilexpress",
        logo: "data:image/png;base64,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"
    },
    {
        titulo: "99 Minutos",
        slug: "99minutos",
        logo: "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3f/Logo-99minutos.svg/1200px-Logo-99minutos.svg.png"
    },
    {
        titulo: "PedidosYa",
        slug: "pedidosya",
        logo: "https://lh3.googleusercontent.com/VfxOAPkn2bm0WcRUTu73h1_8EQEFclcJHmkhcMsmLssT2TdgVH-boOO_E2UgI1wiZ0cJS_ARzOeR_dMKGukdw4pVMUxBSlzZInap_AK-Cr8WFzZBMlY"
    },
    {
        titulo: "Pullman Cargo",
        slug: "pullmancargo",
        logo: "https://sucursalescl.com/wp-content/uploads/pullman.jpg"
    },
]

const CotizadorProveedorTransporte = (props) => {
    const {
        id_ruta,
        ordenes
    } = props
    const [ codigoProveedor, setCodigoProveedor ] = useState(497005)
    const [ loading, setLoading ] = useState(false)
    const dispatch = useDispatch()
    const session = useSelector(state => state.miusuario)
    const token = session.tokenSession
    const [courriers, setCourriers] = useState([])
    const [ proveedores, setProveedores ] = useState(default_proveedores)
    const [ servicio, setServicio] = useState({ $nin: [null]})
    const [ tipoSeleccion, setTipoSeleccion ] = useState('todos')
    const [ mensajeLoading, setMensajeLoading ] = useState('')
    const [ origen, setOrigen ] = useState(false)
    const [ regla, setRegla ] = useState(false)
    const [ showModalSeleccionOrdenes, setShowModalSeleccionOrdenes ] = useState(false)
    const [ operacionesListas, setOperacionesListas] = useState(0)
    const [ loadingMaster, setLoadingMaster] = useState(false)
    const [ loadingOperaciones, setLoadingOperaciones] = useState(0)
    const [ registros, setRegistros ] = useState(ordenes)

    const seleccionar = (i) => {
        return false
        proveedores[i].seleccionado = !proveedores[i].seleccionado
        return setProveedores([...[], ...proveedores])
    }

    const confirmarOnline = async (orders)=>{
        return fetch(`${urlapi}/pricing/quotation/confirm`,{
            method:'POST',
            body: JSON.stringify({
                orders,
                codigo_proveedor: codigoProveedor,
                servicio,
                meta_data: { tipo: "logistica", subtipo: "courrier", identificador: "starken" }
            }),
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${token}`
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            if(Array.isArray(res) !== false){
                return res
            }
            return []
        })
        .catch(error => [])
    }

    const cotizarOnline = async (orders)=>{
        return fetch(`${urlapi}/pricing/quotation/external/batch`,{
            method:'POST',
            body: JSON.stringify({
                orders,
                codigo_proveedor: codigoProveedor,
                servicio,
                propietario: "76163495K",
                origen
            }),
            headers: {
                'Content-Type':'application/json',
                'Authorization': `Bearer: ${token}`
            }
        })
        .then(res => {
            if(res.status === 401) return dispatch(cerrarSesion())
            return res.json()
        })
        .then(res => {
            if(Array.isArray(res) !== false){
                return res
            }
            return []
        })
        .catch(error => [])
    }

    const analizarTarifa = (tarifas) => {
        let registros_courriers = []
        if(Array.isArray(tarifas) !== true) return false
        for( const tarifa of tarifas ){
            if(!tarifa.provider) continue
            const i = courriers.findIndex(co => co.name === tarifa.provider)
            if( i < 0){
                registros_courriers.push({
                    name: tarifa.provider
                })
            }
        }
        return registros_courriers
    }

    const analizarResultadosCotizacion = (orders) => {
        let registros_courriers = []
        for( const order of orders ){
            const i = registros.findIndex(o => o.pedido === order.pedido && getDireccion1(o) === order.direccion)
            console.log({i})
            if(i < 0) continue
            if(order.original_geo_datos) registros[i].original_geo_datos = order.original_geo_datos 
            if(order.tarifa){
                registros[i].tarifa = order.tarifa
                const datos_analizados = analizarTarifa(order.tarifa)
                console.log({datos_analizados, tarifas: order.tarifa })
                registros_courriers = [...datos_analizados]
            }
        }
        
        setRegistros(prev => [...[], ...registros])
        return registros_courriers
    }

    const handleChangeTipoSeleccion = (e) => {
        const { value } = e.target
        return setTipoSeleccion(value)
    }

    const handleCloseSeleccionOrdenes = () => {
        setShowModalSeleccionOrdenes(false)
    }

    const onChangeAll = ({value}) => {
        const iterar = registros.map(r => {
            r.seleccionado = value
            return r
        })
        setTimeout(() => {
            console.log(iterar.filter(e => e.seleccionado), "seleccionado")
        }, 100);
        return setRegistros(iterar)
    }

    const onChangeSingular = ({name,value}) => {
        const i = registros.findIndex(o => o._id === name)
        if(i > -1 ){
            registros[i].seleccionado = value
            setTimeout(() => {
                console.log(registros.filter(e => e.seleccionado), "seleccionado")
            }, 100);
            return setRegistros(registros)
        }
    }

    const mostrarOrdenesSeleccion = () => {
        if(registros.length < 1) return false

        return <div className="mt-3">
            <Card bg="info" className="p-2 text-white">
            <h6 className="mb-0">Selecciona las órdenes aquí <Button size="sm" variant="link text-white" onClick={() => setShowModalSeleccionOrdenes(true)}><BiSolidChevronRight size={20} /> <b>VER REGISTROS</b></Button></h6>
            </Card>
            <Modal show={showModalSeleccionOrdenes} size="lg" onHide={handleCloseSeleccionOrdenes} centered >
                <Modal.Header closeButton>
                <Modal.Title>Tarifas cotizadas </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                <TablaOrdenes ordenes={registros} displaySelection={true} onChangeAll={data => onChangeAll(data)} onChangeSingular={data => onChangeSingular(data)} />
                </Modal.Body>
            </Modal>
        </div>
    }

    const mostrarSeleccionRegistros = () => {
        if(tipoSeleccion === "todos"){
            return false
        } else if(tipoSeleccion === "seleccion_ordenes"){
            return <div>
                {mostrarOrdenesSeleccion()}
            </div>
        } else if(tipoSeleccion === "regla"){
            return <div>

            </div>
        }
    }

    const obtenerOrdenesSegunTipoSeleccion = (datos) => {
        if(tipoSeleccion === "todos"){
            return datos
        } else if(tipoSeleccion === "seleccion_ordenes"){
            return datos.filter(o => o.seleccionado === true)
        } else if(tipoSeleccion === "regla"){
            if(!regla){
                toast.error("Selecciona una regla")
                return []
            }
        }
    }

    const confirmarOrdenes = () => {
        if(!servicio) return toast.error("Selecciona un tipo de servicio para la cotización")

        let pedidos = JSON.parse( JSON.stringify( registros ) ).filter(o => o.tarifa)

        if( pedidos.length !== registros.length ) {
            return confirmAlert({
                title: `La cotización no está completa`,
                message: `Cotizaste ${pedidos.length} órdenes pero la ruta tiene ${registros.length}, ¿Estás seguro que deseas confirmar con el courrier solo las ${pedidos.length} órdenes?`,
                buttons: [
                  {
                    label: 'CONFIRMAR',
                    onClick: () => procesarConfirmacionOrdenes()
                  },
                  {
                    label: 'CANCELAR',
                    onClick: () => false
                  }
                ]
              })
        }

        return procesarConfirmacionOrdenes()
    }

    const procesarConfirmacionOrdenes = async () => {
        if(!servicio) return toast.error("Selecciona un tipo de servicio para la cotización")

        let pedidos = JSON.parse( JSON.stringify( registros ) ).filter(o => o.tarifa)

        setMensajeLoading('Confirmando órdenes, no cierres la ventana')
        setLoadingMaster(true)
        setLoadingOperaciones(pedidos.length)
        setOperacionesListas(0)
        let total_procesadas = 0

        const dividir = sliceIntoChunks(pedidos, 50)
            for( const array of dividir ){
                const resultados = await confirmarOnline(array)
                total_procesadas = total_procesadas + array.length
                setOperacionesListas(total_procesadas)
        }

        setLoadingMaster(false)
        toast.success("Progreso finalizado")
    }

    const cotizarOrdenes = async (faltantes) => {
        setCourriers([])
        if(!servicio) return toast.error("Selecciona un tipo de servicio para la cotización")

        let pedidos = JSON.parse( JSON.stringify( registros ) )

        if(faltantes === true){
            pedidos = pedidos.filter(op => !op.tarifa)
        } else {
            registros.map(reg => {
                reg.tarifa = false
            return reg
            })
        }

        const filtrar_sin_tarifa = obtenerOrdenesSegunTipoSeleccion(pedidos) //.filter(pe => !pe.tarifa || parseInt(pe.tarifa) < 1)
        if(filtrar_sin_tarifa.length < 1) return false
        //if(filtrar_sin_tarifa.length < 1) return toast.error('No hay pedidos pendientes de cotizar')
        
        // this.setState({ cotizando: true, operaciones_loading: filtrar_sin_tarifa.length, operaciones_loading_done:0, operaciones_mensajes: [] })
        setMensajeLoading('Cotizando')
        setLoadingMaster(true)
        setLoadingOperaciones(filtrar_sin_tarifa.length)
        setOperacionesListas(0)
        let total_procesadas = 0
        let proveedores = []
        const dividir = sliceIntoChunks(filtrar_sin_tarifa, 50)
            for( const array of dividir ){
                const resultados = await cotizarOnline(array)
                const courriers_ = analizarResultadosCotizacion(resultados)
                console.log({ courriers_, resultados })
                proveedores = [...[], ...courriers_]
                total_procesadas = total_procesadas + array.length
                setOperacionesListas(total_procesadas)
        }
        setCourriers([...[], ...proveedores])
        setLoadingMaster(false)
        toast.success("Progreso finalizado")
    }

    const setearOrigen = (data) => {
        if(data) if(typeof data === "object") if(data.geodata) if(typeof data.geodata === "object"){
            setOrigen(data.geodata)
        }
    }

    const mostrarProveedores = () => {
        if(proveedores.length < 1) return <SinDatos />

        let cantidad_parcial = 0
        const con_tarifa = registros.filter(o => o.tarifa).length
        const sin_tarifa = registros.filter(o => !o.tarifa).length
        if(con_tarifa > 0 && sin_tarifa > 0) cantidad_parcial = sin_tarifa

        return <div>
            {/* <h4>Proveedores integrados</h4>
            <Row className="mb-3">
            {
                proveedores.map((prov,i) => {
                    const estilo_activo = prov.seleccionado ? { border: `2px solid ${estilo_last_mile.color_primary}` } : {}
                    return <Col md={2} key={`pro-${i}`} className="hover"   onClick={() => seleccionar(i)}>
                        <Card className="p-3 d-flex centrador" style={{...estilo_activo, minHeight: 100 }} >
                        {prov.logo ? <img src={prov.logo} style={{ width: "60%", margin: "0 auto" }} /> : <h4>{prov.titulo}</h4> }
                        </Card>
                    </Col>
                })
            }
            </Row> */}
            <label className="form-control-label d-block">¿Cómo deseas seleccionar las órdenes a cotizar?</label>
            <select className="form-control mb-3" onChange={handleChangeTipoSeleccion}>
                <option value="todos">Ruta completa</option>
                {/* <option value="regla">Seleccionar regla</option> */}
                <option value="seleccion_ordenes">Seleccionar órdenes</option>
            </select>

            {mostrarSeleccionRegistros()}

            {/* <ButtonGroup>
            { tipoSeleccion !== "seleccion_ordenes" ? cantidad_parcial > 0 ? <Button disabled={loadingMaster}  onClick={() => cotizarOrdenes(true)} variant='light' >COTIZAR {cantidad_parcial} FALTANTES</Button> : false  : false }
            <Button disabled={loadingMaster}  onClick={() => cotizarOrdenes()} variant='light' >COTIZAR</Button>
            </ButtonGroup> */}
        </div>
    }

    const mostrarTarifas = () => {
        const filter = registros.filter(o => o.tarifa)
        if(filter.length < 1) return <RegistrosVacios />

        const otros_registros = registros.filter(re => {
            if(!re.tarifa) return true
            if(!Array.isArray(re.tarifa)) return true
            if(re.tarifa.length < 1) return true
            return false
        })

        const data = courriers.map((cour,ic) => {

            const filtrado = registros.filter(re => {
                if(!re.tarifa) return false
                if(!Array.isArray(re.tarifa)) return false
                return re.tarifa.filter(ta => ta.provider === cour.name).length > 0 ? true : false
            })

            const calcular = filtrado.reduce((prev,next) => {
                let sumar = 0
                const encontrar = next.tarifa.findIndex(ta => ta.provider === cour.name)
                if(encontrar > -1 ){
                    const tarifas_encontradas = next.tarifa[encontrar].tarifas
                    if(tarifas_encontradas.length > 0){
                        if(tarifas_encontradas[0].price) sumar = tarifas_encontradas[0].price
                    }
                }
                return prev + sumar
            }, 0)

            return {
                label: cour.name,
                total: calcular
            }
        })

        const data_graph = {
            labels: data.map(da => da.label.toUpperCase()),
            datasets: [
            {
                label: 'Monto cotización',
                data: data.map(da => da.total),
                backgroundColor: [
                estilo_last_mile.color_primary,
                estilo_last_mile.color_secondary,
                estilo_last_mile.color_third,
                ]
            },
            ],
        }

        const options_graph = {
            responsive: true
        }

        return <div className="mt-3">

            {filter.length !== registros.length ? <div>
                <h6 className="mb-0 text-warning"><PiWarningCircleBold size={20}  /> La cotización fue parcial</h6>
            </div> : false}

            <h4>{filter.length} órdenes cotizadas de {registros.length}</h4>
            <div style={{ maxHeight: 200 }}><Bar options={options_graph} data={data_graph} /></div>
            
                <Row>
                    {
                        courriers.map((cour,ic) => {

                            const filtrado = registros.filter(re => {
                                if(!re.tarifa) return false
                                if(!Array.isArray(re.tarifa)) return false
                                return re.tarifa.filter(ta => ta.provider === cour.name).length > 0 ? true : false
                            })

                            const calcular = filtrado.reduce((prev,next) => {
                                let sumar = 0
                                const encontrar = next.tarifa.findIndex(ta => ta.provider === cour.name)
                                if(encontrar > -1 ){
                                    const tarifas_encontradas = next.tarifa[encontrar].tarifas
                                    if(tarifas_encontradas.length > 0){
                                        if(tarifas_encontradas[0].price) sumar = tarifas_encontradas[0].price
                                    }
                                }
                                return prev + sumar
                            }, 0)

                            return <Col key={`cou-${ic}`} md={3} className="mb-3">
                            <Card className="p-3 text-center centrador">
                                <h4 style={{ textTransform: "uppercase" }} className="mb-0">{cour.name}</h4>
                                <h6 className="mb-0">{filtrado.length} Tarifas encontradas</h6>
                                <h6 className='mb-0'>Total cotización: <b className='text-success'>${formatoMoneda(calcular)}</b></h6>
                            </Card>
                        </Col>
                        })
                    }
                </Row>
                
                <Tabs
                defaultActiveKey="courrier-1"
                className="mb-3"
        >
    
        {
            courriers.map((cou,ic) => {

                const filtrado = registros.filter(re => {
                    if(!re.tarifa) return false
                    if(!Array.isArray(re.tarifa)) return false
                    return re.tarifa.filter(ta => ta.provider === cou.name)
                })

                const calcular_total = filtrado.reduce((prev,next) => {
                    let sumar = 0
                    const encontrar = next.tarifa.findIndex(ta => ta.provider === cou.name)
                    if(encontrar > -1 ){
                        const tarifas_encontradas = next.tarifa[encontrar].tarifas
                        if(tarifas_encontradas.length > 0){
                            if(tarifas_encontradas[0].price) sumar = tarifas_encontradas[0].price
                        }
                    }
                    return prev + sumar
                }, 0)

                return <Tab eventKey={`courrier-${(ic+1)}`} title={`${cou.name}`}>
                    <h4>{filtrado.length} Registros </h4>
                    <Button size="sm" variant="success" >CONFIRMAR ${formatoMoneda(calcular_total)}</Button>
                    <Table>
                        <thead>
                            <tr>
                                <th>REFERENCIA</th>
                                <th>COURRIER</th>
                                <th>DIRECCION</th>
                                <th>TARIFA</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                filtrado.map((reg,ire) => {
                                    let tarifa = false
                                    if(reg.tarifa) if(Array.isArray(reg.tarifa) !== false){
                                        const i = reg.tarifa.findIndex(ta => ta.provider === cou.name)
                                        if(i > -1 ){
                                            const precios = reg.tarifa[i].tarifas
                                            if(Array.isArray(precios) !== false) if(precios.length > 0) if(precios[0].price) if(!isNaN(parseFloat(precios[0].price))) tarifa = precios[0].price
                                        }
                                    }
                                    return <tr key={`tabla-${ire}`}>
                                    <th>{reg.pedido}</th>
                                    <th style={{ textTransform: "uppercase" }}>{cou.name}</th>
                                    <th>{getDireccion1(reg)}</th>
                                    <th>{tarifa !== false ? formatoMoneda(tarifa) : <span className="text-danger"><PiWarningCircleBold size={20}  /></span> }</th>
                                </tr>
                                })
                            }
                        </tbody>
                    </Table>
                </Tab>
            })
        }
        <Tab eventKey={`courrier-otros`} title={`Otros`}>
            <h4>{otros_registros.length} Registros</h4>
                    <Table>
                        <thead>
                            <tr>
                                <th>REFERENCIA</th>
                                <th>COURRIER</th>
                                <th>DIRECCION</th>
                                <th>TARIFA</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                otros_registros.map((reg,ire) => {
                                    let tarifa = false
                                    return <tr key={`tabla-${ire}`}>
                                    <th>{reg.pedido}</th>
                                    <th>STARKEN</th>
                                    <th>{getDireccion1(reg)}</th>
                                    <th>{tarifa !== false ? formatoMoneda(tarifa) : <span className="text-danger"><PiWarningCircleBold size={20}  /></span> }</th>
                                </tr>
                                })
                            }
                        </tbody>
                    </Table>
                </Tab>
         </Tabs>
        </div>
    }

    const convertirDatos = (regs) => {
        let data = []

        for( const ped of regs ){
            const payload = {
                    referencia: ped.pedido,
                    vehiculo: '',
                    origen_direccion_excel: ped?.origen?.address_1,
                    productos: [
                        // { 
                        //     description: row[reemplazarLlave("item")] ? row[reemplazarLlave("item")].toString() : '',
                        //     peso: row[reemplazarLlave("peso")] ? parseInt(row[reemplazarLlave("peso")]) : 0,
                        //     alto: row[reemplazarLlave("alto")] ? parseInt(row[reemplazarLlave("alto")]) : 0,
                        //     ancho: row[reemplazarLlave("ancho")] ? parseInt(row[reemplazarLlave("ancho")]) : 0,
                        //     largo: row[reemplazarLlave("largo")] ? parseInt(row[reemplazarLlave("largo")]) : 0,
                        //     quantity: cantidad,
                        //     codigo_item: row[reemplazarLlave("codigo_item")] ? row[reemplazarLlave("codigo_item")].toString() : '',
                        //     price: row[reemplazarLlave("precio_item")] ? parseInt(row[reemplazarLlave("precio_item")]) : 0,
                        // }
                    ],
                    identificador_contacto: '',
                    nombre_contacto: ped.orden?.billing?.first_name,
                    telefono: ped.orden?.billing?.phone,
                    email_contacto: ped?.orden?.billing?.email ? ped?.orden?.billing?.email.toString().trim() : "",
                    direccion: ped?.orden?.billing?.address_1,
                    observaciones_direccion: ped?.orden?.billing?.address_2,
                    nota: ped?.nota,
                    fecha_min_entrega: ped?.fecha_min_entrega,
                    fecha_max_entrega: ped?.fecha_max_entrega,
                    // codigo_destino: row[reemplazarLlave("codigo_destino")] ? row[reemplazarLlave("codigo_destino")] : '',
                    meta_data: [],
                    emails_adicionales: []
            }
            if(ped?.orden?.origen) payload.origen = ped.orden.origen
            if(ped?.orden?.geo_datos_origen) payload.origen = {...payload.origen, ...ped.orden.geo_datos_origen }
            data.push(payload)
        }
        return data
    }

    const data = convertirDatos(registros)

    return <div>
        {mostrarProveedores()}
        <RutasImportador tipo_asignacion_default="proveedor" registros_default={data} />
        {/* {mostrarTarifas()}
        <CargandoFlotante visualizar={loadingMaster} mensaje={mensajeLoading} procesando={loadingOperaciones} procesado={operacionesListas}  /> */}
    </div>
}

export default CotizadorProveedorTransporte